import { SignIn, SignUp } from '@clerk/clerk-react'
import { Link, useSearchParams } from 'react-router-dom'

/** Clerk owns the form; we only decide where a signed-in user lands. */
function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="shell">
      <header className="shell__bar">
        <Link to="/" className="wordmark">
          detach<span>ly</span>
        </Link>
      </header>
      <main className="shell__main">
        <div className="center-panel">{children}</div>
      </main>
    </div>
  )
}

function useRedirectTarget(): string {
  const [params] = useSearchParams()
  const target = params.get('redirect_url')
  // Only in-app paths: an absolute URL here would be an open redirect.
  return target && target.startsWith('/app') ? target : '/app/projects'
}

export function SignInPage() {
  const target = useRedirectTarget()
  return (
    <AuthLayout>
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" forceRedirectUrl={target} />
    </AuthLayout>
  )
}

export function SignUpPage() {
  const target = useRedirectTarget()
  return (
    <AuthLayout>
      <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" forceRedirectUrl={target} />
    </AuthLayout>
  )
}
